import axios from "axios";

require("../../libs/plugins/owl.carousel");

window.addEventListener("load", async () => {
  const viewedProductsData = localStorage.getItem("recentlyViewedProducts");

  const viewedProducts =
    viewedProductsData != null ? JSON.parse(viewedProductsData) : [];

  const recentlyViewedProductsContainer = document.querySelector(
    "#recently-viewed-products"
  );

  if (viewedProducts.length >= 3) {
    const shopifyApiKey = window.mmkt.config.shopifyApiKey;
    const query = `query:\\"status:ACTIVE AND (${viewedProducts
      .map((product) => product.id)
      .join(" OR ")})\\"`;

    const {
      data: {
        data: {
          products: { nodes: shopifyProducts },
        },
      },
    } = await axios(
      `https://mediamarkt-canarias.myshopify.com/api/2023-01/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": shopifyApiKey,
        },
        data: `{ "query": "{ products(first: 50, ${query}) { nodes { id handle featuredImage { url } priceRange { minVariantPrice { amount } } compareAtPriceRange { minVariantPrice { amount } } } } }" }`,
      }
    );

    const formatPrice = (price) => {
      price = price.toString();

      const zeroDecimals = toString().includes(".00");

      price = price.replace("€", "");
      price = price.replace(",", "");
      price = price.replace(".00", "");

      price = price.concat(zeroDecimals ? ",- €" : " €");

      return price;
    };

    viewedProducts.reverse();
    await Promise.all(
      viewedProducts.map(async (recentProduct) => {
        const shopiProduct = shopifyProducts.find((product) =>
          product.id.includes(recentProduct.id)
        );

        let stickersInnerHtml = "";
        let imageUrl = "";

        if (shopiProduct) {
          const {
            handle,
            compareAtPriceRange: {
              minVariantPrice: { amount: compareAtPrice },
            },
            priceRange: {
              minVariantPrice: { amount: price },
            },
            featuredImage: { url },
          } = shopiProduct;

          const res = await fetch(`/products/${handle}`);

          const data = await res.text();

          const html = document.createElement("html");
          html.innerHTML = data;

          const sitckersContainer = html.querySelector(
            ".product-left-column > .product-campaigns-stickers"
          );

          stickersInnerHtml = sitckersContainer?.innerHTML || "";
          imageUrl = url;

          recentProduct.price = Number(price) * 100;
          recentProduct.compareAtPrice = Number(compareAtPrice) * 100;
        }

        const price = recentProduct.price;
        const compareAtPrice = recentProduct.compareAtPrice;

        const viewedProductContainer = document.createElement("div");
        viewedProductContainer.classList.add("item");

        const priceFormated = formatPrice(Number(price || 0) / 100);
        const compareAtPriceFormated = formatPrice(
          Number(compareAtPrice || 0) / 100
        );

        const priceMarkup = `
          <div class="content_price" data-price="${price}" data-compare-at-price="${compareAtPrice}">
          ${
            compareAtPrice > price
              ? `<span class="compare-at-price">${compareAtPriceFormated}</span>`
              : ""
          }
            <span class="regular-price ${
              compareAtPrice > price ? `sale-price` : ""
            }">${priceFormated}</span>
          </div>
        `;

        viewedProductContainer.innerHTML = `
        <div class="product_block">
          <div class="product-container text-left product-block">
            <div class="product-campaigns-stickers">
              ${stickersInnerHtml}
            </div>
            <div class="product-image-container image">
              <a class="product_img_link" href="${recentProduct.url}" title="${
          recentProduct.productTitle
        }">
                <img class="replace-2x img-responsive" src="${
                  Shopify.Products.resizeImage(
                    recentProduct.productImg || imageUrl,
                    "medium"
                  ) ||
                  recentProduct.productImg ||
                  imageUrl
                }" loading="lazy" alt="${recentProduct.productTitle}" />
              </a>
            </div>
            <div class="product-meta">
              <h3 class="name">
                <a class="product-name" href="${recentProduct.url}" title="${
          recentProduct.productTitle
        }">
                  ${recentProduct.productTitle}
                </a>
              </h3>
              <div class="review">
                <span class="spr-badge" id="spr_badge_${
                  recentProduct.id
                }" data-rating="4.428571428571429">
                  <span class="spr-starrating spr-badge-starrating">
                    <i class="spr-icon spr-icon-star" aria-hidden="true"></i>
                    <i class="spr-icon spr-icon-star" aria-hidden="true"></i>
                    <i class="spr-icon spr-icon-star" aria-hidden="true"></i>
                    <i class="spr-icon spr-icon-star" aria-hidden="true"></i>
                    <i class="spr-icon spr-icon-star-half-alt" aria-hidden="true"></i>
                  </span>
                  <span class="spr-badge-caption"></span>
                </span>
              </div>
                ${priceMarkup}
              <div class="functional-buttons"></div>
            </div>
          </div>
        </div>`;

        recentlyViewedProductsContainer.appendChild(viewedProductContainer);
      })
    );

    document.querySelector("#last-viewed-products").removeAttribute("style");
    document
      .querySelector("#recently-viewed-products")
      .removeAttribute("style");
  }

  $("#recently-viewed-products").owlCarousel({
    stagePadding: 500,
    items: 5,
    loop: false,
    navigation: true,
    addClassActive: true,
    afterInit: SetOwlCarouselFirstLast,
    afterAction: SetOwlCarouselFirstLast,
    autoPlay: 10000,
    itemsDesktop: [1199, 3],
    itemsDesktopSmall: [979, 2],
    itemsTablet: [768, 2],
    itemsTabletSmall: [480, 1],
    itemsMobile: [360, 1],
  });

  function SetOwlCarouselFirstLast(el) {
    el.find(".owl-item").removeClass("first");
    el.find(".owl-item.active").first().addClass("first");
    el.find(".owl-item").removeClass("last");
    el.find(".owl-item.active").last().addClass("last");
  }
});
